import { render, staticRenderFns } from "./ConfirmRemove.vue?vue&type=template&id=0bc1ffbe&scoped=true&lang=pug"
import script from "./ConfirmRemove.vue?vue&type=script&lang=ts"
export * from "./ConfirmRemove.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmRemove.vue?vue&type=style&index=0&id=0bc1ffbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1ffbe",
  null
  
)

export default component.exports